import SupportedLobModules from 'integration/quoteandbind/SupportedLobModules';
import 'edge/quoteandbind/quickquote/app';
import 'edge/policyjob/app';
import 'edge/policycommon/app';
import 'edge/platform/navigation/module';
import 'gw-portals-cp-components-angular';

var qnbDependencies = SupportedLobModules;

qnbDependencies.push('edge.quoteandbind.quickquote.app');
qnbDependencies.push('edge.policyjob.app');
qnbDependencies.push('edge.policycommon.app');
qnbDependencies.push('edge.platform.navigation');
qnbDependencies.push('edge.quoteandbind.quickquote.app');
qnbDependencies.push('gw-portals-cp-components-angular');

export default angular.module('edge.quoteandbind.app', qnbDependencies).config(['EventHubProvider', function (EventHubProvider) {
    var quoteAndBindMethods = ['create', 'retrieve', 'saveAndQuote', 'bind'];

    EventHubProvider.registerTransformer({
        source: {
            category: 'tracking',
            eventName: 'serverCall'
        },
        target: {
            category: 'journey',
            eventName: 'submission'
        },
        transformer: function transformer(payload, send) {
            if (payload && payload.success && payload.path === 'quote' && quoteAndBindMethods.includes(payload.method)) {
                var response = payload.response;
                var baseData = response.baseData;
                var newPayload = {
                    method: payload.method,
                    accountNumber: baseData.accountNumber,
                    quoteID: response.quoteID,
                    productCode: baseData.productCode

                };
                if (payload.method === 'bind') {
                    send(Object.assign(newPayload, {
                        policyNumber: response.bindData.policyNumber
                    }));
                } else {
                    send(newPayload);
                }
            }
        }
    });

    EventHubProvider.registerTransformer({
        source: {
            category: 'tracking',
            eventName: 'serverCall'
        },
        target: {
            category: 'tracking',
            eventName: 'journey'
        },
        transformer: function transformer(payload, send) {
            if (payload.path === 'quote' && payload.success) {
                if (payload.method === 'create') {
                    var response = payload.response;
                    var baseData = payload.response.baseData;
                    send({
                        eventName: 'Submission Created',
                        accountNumber: baseData.accountNumber,
                        jobID: response.quoteID,
                        productCode: baseData.productCode,
                        accountHolder: {
                            name: baseData.accountHolder.displayName,
                            address: baseData.accountHolder.primaryAddress.displayName,
                            email: baseData.accountHolder.emailAddress1
                        }
                    });
                } else if (payload.method === 'retrieve') {
                    var _response = payload.response;
                    var _baseData = payload.response.baseData;
                    send({
                        eventName: 'Submission Retrieved',
                        accountNumber: _baseData.accountNumber,
                        jobID: _response.quoteID,
                        productCode: _baseData.productCode
                    });
                } else if (payload.method === 'saveAndQuote') {
                    var _response2 = payload.response;
                    var _baseData2 = _response2.baseData;
                    var quoteData = _response2.quoteData;
                    quoteData.offeredQuotes.forEach(function (q) {
                        if (!q.isCustom) {
                            send({
                                eventName: 'Quote Showed',
                                accountNumber: _baseData2.accountNumber,
                                jobID: _response2.quoteID,
                                productCode: _baseData2.productCode,
                                branchCode: q.branchCode,
                                value: q.total
                            });
                        }
                    });
                } else if (payload.method === 'bind') {
                    var _response3 = payload.response;
                    var _baseData3 = _response3.baseData;
                    var bindData = _response3.bindData;
                    var _quoteData = _response3.quoteData;
                    send({
                        eventName: 'Policy Bound',
                        accountNumber: _baseData3.accountNumber,
                        policyNumber: bindData.policyNumber,
                        jobID: _response3.quoteID,
                        paymentPlan: bindData.paymentPlans[0].name,
                        value: _quoteData.offeredQuotes[0].premium.total
                    });
                }
            } else if (payload.path === 'customquote' && payload.method === 'updateCustomQuote' && payload.success) {
                var _response4 = payload.response;
                send({
                    eventName: 'Quote Showed',
                    jobID: _response4.quoteID,
                    branchCode: _response4.branchCode,
                    value: _response4.total
                });
            }
        }
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/app.js
// module id = 1199
// module chunks = 0